import { render } from "./matching-card-percentage-pill.vue?vue&type=template&id=4953c67c&scoped=true&ts=true"
import script from "./matching-card-percentage-pill.vue?vue&type=script&lang=ts"
export * from "./matching-card-percentage-pill.vue?vue&type=script&lang=ts"

import "./matching-card-percentage-pill.vue?vue&type=style&index=0&id=4953c67c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4953c67c"]])

export default __exports__